import React from "react";
import { FeedQueryUp, FeedQueryDown } from "../PageHelpers";

// This banner is used on the ListFeed template
const ListFeedBanner = ({ page, latest }) => {
  if (!latest) {
    return (
      <div className="banner--list-feed relative">
        <div className="banner--list-feed__bg absolute h-100 w-100 bg-stone" />
        <div className="pt3 pt5-l ph2 pb2 pb3-l relative flex flex-column items-center">
          <h1 className="h-2 h-1--l dark mb0 tc mw-530">{page.title}</h1>
          {page.subtitle && (
            <h2 className="h-5 dark ttu tc pt1 pt2-l mb0 mw-530">
              {page.subtitle}
            </h2>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="banner--list-feed relative">
      <div className="banner--list-feed__bg absolute h-100 w-100 bg-stone" />
      <div className="pt3 pt5-l ph2 pb2 pb3-l relative flex flex-column items-center">
        <h1 className="h-2 h-1--l dark mb0 tc mw-530">{page.title}</h1>
        {page.subtitle && (
          <h2 className="h-5 dark ttu tc pt1 pt2-l mb0 mw-530">
            {page.subtitle}
          </h2>
        )}
      </div>
      {latest.template === "Story" ? (
        <FeedQueryDown page={latest} />
      ) : (
        <FeedQueryUp page={latest} />
      )}
    </div>
  );
};

export default ListFeedBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/ListFeedBanner.js